import { Component, Input, OnDestroy, OnInit, HostListener } from '@angular/core';
import * as Highcharts from 'highcharts';

import { TimeoutWrapperService } from '@nrwl/common-lib';
import { isEmpty, debounce, uniqueId } from 'lodash';

@Component({
  selector: 'nrwl-trending-chart',
  templateUrl: './trending.chart.component.html',
  styleUrls: ['./trending.chart.component.scss']
})
export class TrendingChartComponent implements OnInit, OnDestroy {
  @Input() options;
  @Input() id;
  idData: string;
  chart: Highcharts.Chart;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  boundedWindowResizeListener: any;
  constructor(private timeout: TimeoutWrapperService) {
    this.idData = uniqueId('reports-trending-chart_');
    this.boundedWindowResizeListener = debounce(() => {
      this.onResizeEvent();
    }, 300);
  }

  @HostListener('window:resize')
  // eslint-disable-next-line
  onResize(event): void {
    this.boundedWindowResizeListener(event);
  }

  ngOnInit(): void {
    this._createChart();
  }

  ngOnDestroy() {
    if (!isEmpty(this.chart)) {
      this.chart.destroy();
    }
  }

  onResizeEvent(): void {
    if (!isEmpty(this.chart)) {
      this.chart.destroy();
    }
    this.timeout.add(() => this.draw(), 0);
  }

  private _createChart(): void {
    this.timeout.add(() => this.draw(), 0);
  }

  private draw(): void {
    this.chart = Highcharts.chart(this.idData, this.options);
  }
}
